import { Link } from "react-router-dom";
import GoPratle from "../../assets/GoPratle.png";
import { Youtube, Facebook, Instagram, Linkedin } from "lucide-react";
import xIcon from "../../assets/x.svg";

const Footer = () => {
  return (
    <footer className="bg-white border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16 py-8 md:py-12">
        <div className="flex flex-col lg:flex-row justify-between gap-8 lg:gap-12">
          <div className="max-w-sm mx-auto lg:mx-0">
            <div className="mb-4 flex items-center justify-center lg:justify-start">
              <Link to="/">
                <img
                  src={GoPratle}
                  alt="GoPratle Logo"
                  className="w-32 sm:w-36 md:w-40 h-auto object-contain"
                />
              </Link>
            </div>
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-black mb-2 text-center lg:text-left">
              Stress-free &{" "}
              <span className="text-[#FF4C18] font-semibold">tailored</span> for
              you.
            </h2>
            <p className="text-gray-600 mb-6 text-sm md:text-base leading-relaxed text-center lg:text-left">
              Connect with top event managers and agencies to create
              unforgettable experiences for any occasion.
            </p>
            <div className="flex justify-center lg:justify-start gap-2">
              <a
                href="https://facebook.com/profile.php?id=61577127366798"
                target="_blank"
                rel="noreferrer"
                className="p-2 w-10 h-10 border border-black rounded-md flex items-center justify-center"
              >
                <Facebook className="w-full h-full" />
              </a>
              <a
                href="https://instagram.com/gopratle"
                target="_blank"
                rel="noreferrer"
                className="p-2 w-10 h-10 border border-black rounded-md flex items-center justify-center"
              >
                <Instagram className="w-full h-full" />
              </a>
              <a
                href="https://linkedin.com/company/gopratle"
                target="_blank"
                rel="noreferrer"
                className="p-2 w-10 h-10 border border-black rounded-md flex items-center justify-center"
              >
                <Linkedin className="w-full h-full" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCctXZ7cH_td0R95NjRFHwPQ"
                target="_blank"
                rel="noreferrer"
                className="p-2 w-10 h-10 border border-black rounded-md flex items-center justify-center"
              >
                <Youtube className="w-full h-full" />
              </a>
              <a
                href="https://x.com/gopratle"
                target="_blank"
                rel="noreferrer"
                className="p-2 w-10 h-10 border border-black rounded-md flex items-center justify-center"
              >
                <img src={xIcon} alt="X" className="w-full h-full" />
              </a>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 md:gap-12 lg:gap-16 mt-8 lg:mt-0 justify-between md:justify-normal">
            <div>
              <h4 className="text-black font-semibold mb-3 md:mb-4 text-left text-sm md:text-lg">
                Resources
              </h4>
              <ul className="space-y-2 md:space-y-4">
                <li>
                  <Link
                    to="/about"
                    className="text-gray-600 hover:text-[#FF4C18] transition block text-left text-xs md:text-base"
                    style={{ fontFamily: "CabinetGrotesk-Medium" }}
                  >
                    About us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/under-construction"
                    className="text-gray-600 hover:text-[#FF4C18] transition block text-left text-xs md:text-base"
                    style={{ fontFamily: "CabinetGrotesk-Medium" }}
                  >
                    Career
                  </Link>
                </li>
                <li>
                  <Link
                    to="/under-construction"
                    className="text-gray-600 hover:text-[#FF4C18] transition block text-left text-xs md:text-base"
                    style={{ fontFamily: "CabinetGrotesk-Medium" }}
                  >
                    Sitemap
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-black font-semibold mb-3 md:mb-4 text-left text-sm md:text-lg">
                Support
              </h4>
              <ul className="space-y-2 md:space-y-4">
                <li>
                  <Link
                    to="/help"
                    className="text-gray-600 hover:text-[#FF4C18] transition block text-left text-xs md:text-base"
                    style={{ fontFamily: "CabinetGrotesk-Medium" }}
                  >
                    Help Center
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact-us"
                    className="text-gray-600 hover:text-[#FF4C18] transition block text-left text-xs md:text-base"
                    style={{ fontFamily: "CabinetGrotesk-Medium" }}
                  >
                    Contact us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/under-construction"
                    className="text-gray-600 hover:text-[#FF4C18] transition block text-left text-xs md:text-base"
                    style={{ fontFamily: "CabinetGrotesk-Medium" }}
                  >
                    FAQ's
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-black font-semibold mb-3 md:mb-4 text-left text-sm md:text-lg">
                Partner
              </h4>
              <ul className="space-y-2 md:space-y-4">
                <li>
                  <Link
                    to="/join-us"
                    className="text-gray-600 hover:text-[#FF4C18] transition block text-left text-xs md:text-base"
                    style={{ fontFamily: "CabinetGrotesk-Medium" }}
                  >
                    Join Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/b2b"
                    className="text-gray-600 hover:text-[#FF4C18] transition block text-left text-xs md:text-base"
                    style={{ fontFamily: "CabinetGrotesk-Medium" }}
                  >
                    B2B
                  </Link>
                </li>
                <li>
                  <Link
                    to="/under-construction"
                    className="text-gray-600 hover:text-[#FF4C18] transition block text-left text-xs md:text-base"
                    style={{ fontFamily: "CabinetGrotesk-Medium" }}
                  >
                    Affiliate
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 my-6 md:my-8"></div>
        <div className="flex flex-col md:flex-row justify-between items-center text-gray-800 text-sm md:text-base gap-4 md:gap-0">
          <p
            className="text-center md:text-left"
            style={{ fontFamily: "CabinetGrotesk-Bold" }}
          >
            © 2026 GoPratle. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6">
            <Link
              to="/privacy-policy"
              className="hover:text-[#FF4C18] transition underline"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-and-conditions"
              className="hover:text-[#FF4C18] transition underline"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
      {/* </div> */}
    </footer>
  );
};

export default Footer;
